import { render, staticRenderFns } from "./advList.vue?vue&type=template&id=02047fa7&scoped=true"
import script from "./advList.vue?vue&type=script&lang=js"
export * from "./advList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02047fa7",
  null
  
)

export default component.exports